import {
  GET_INBOX_REQUEST,
  GET_INBOX_SUCCESS,
  GET_INBOX_ERROR,
  GET_REQUEST_REQUEST,
  GET_REQUEST_SUCCESS,
  GET_REQUEST_ERROR,
  DECIDE_REQUEST,
  DECIDE_SUCCESS,
  DECIDE_ERROR,
  GET_AWAITING_REQUEST,
  GET_AWAITING_SUCCESS,
  GET_AWAITING_ERROR,
} from './workflowActionTypes';

const initialState = {
  isLoading: false,
  isSaving: false,
  message: '',
  requests: [],
  pagination: {},
  request: null,
  awaiting: [],
  awaitingCount: 0,
  isLoadingAwaiting: false,
};

// Every branch spreads `state` first (see CLAUDE.md): an action carries only
// the flags it changes.
export default function workflowReducer(state = initialState, action) {
  const { type, payload, message } = action;

  switch (type) {
    case GET_INBOX_REQUEST:
      return { ...state, isLoading: true };
    case GET_INBOX_SUCCESS:
      return { ...state, isLoading: false, requests: payload.data, pagination: payload };
    case GET_INBOX_ERROR:
      return { ...state, isLoading: false, message };

    case GET_REQUEST_REQUEST:
      return { ...state, isLoading: true };
    case GET_REQUEST_SUCCESS:
      return { ...state, isLoading: false, request: payload.data };
    case GET_REQUEST_ERROR:
      return { ...state, isLoading: false, request: null, message };

    // A decision returns the updated request; show it without a refetch.
    case DECIDE_REQUEST:
      return { ...state, isSaving: true };
    case DECIDE_SUCCESS:
      return { ...state, isSaving: false, request: payload.data, message };
    case DECIDE_ERROR:
      return { ...state, isSaving: false, message };

    case GET_AWAITING_REQUEST:
      return { ...state, isLoadingAwaiting: true };
    case GET_AWAITING_SUCCESS:
      return { ...state, isLoadingAwaiting: false, awaiting: payload.data, awaitingCount: payload.count };
    case GET_AWAITING_ERROR:
      return { ...state, isLoadingAwaiting: false };

    default:
      return state;
  }
}
